"use strict";

exports.__esModule = true;
exports.default = void 0;

var _scrollspy = require("./scrollspy");

var _plugins = require("../../utils/plugins");

var directives = {
  BScrollspy: _scrollspy.default
};
var _default = {
  install: (0, _plugins.installFactory)({
    directives: directives
  })
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/directives/scrollspy/index.js
// module id = TaNr
// module chunks = 14